import React, {useState} from "react";
import { Table} from "antd";
import {
	computeRowsAndColsForTransactionsPage
} from "../../../pages/chargers/utils/functions";
import { useNavigate } from "react-router-dom"; 
import { Transactions } from "pages/transactions/Transactions";
import useWindowDimensions from "common/functions";
import { Modal } from 'antd';


interface ITable {
	data: Transactions
	selectedFilter?: string;
	setNewSort: (value: string) => void;
	shouldReset: (value: boolean) => void;
	reset: boolean;
	offset: number;
	setOffset: (value: number) => void;
	limit: number;
	length: number;
	setTransactions: (value: Transactions) => void;
	setReset: (value: boolean) => void;
	transactions: Transactions,
	setRefundParams: any;
	setIsModalOpen: (value: boolean) => void;
	setRefundMax: (value: number) => void;
}

const TransactionsTable: React.FC<ITable> = ({
	offset,
	setOffset,
	data,
	setNewSort,
	shouldReset,
	reset,
	length,
	limit,
	setTransactions,
	setReset,
	transactions,
	setRefundParams,
	setIsModalOpen,
	setRefundMax
}) => {

	const navigate = useNavigate();

	const { width } = useWindowDimensions();

	const [isAsc, setIsAsc] = useState({startTime: false, endTime: false, energy: false, revenue: false});
	const [isDesc, setIsDesc] = useState({startTime: false, endTime: false, energy: false, revenue: false});
	
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [currentTransaction, setCurrentTransaction] = useState(null);

	const {columns, rows} = computeRowsAndColsForTransactionsPage(data,
		navigate,
		(value) => setNewSort(value),
		shouldReset,
		reset,
		isAsc,
		isDesc,
		(value) => setIsAsc(value),
		(value) => setIsDesc(value), 
		(value) => setTransactions(value),
		(value) => setReset(value),
		transactions,
		(value) => setRefundParams(value),
		(value) => setIsModalOpen(value),
		(value) => setRefundMax(value),
		(value) => setCurrentTransaction(value),
		(value) => setIsModalVisible(value),
	);

	return (
		<>
		<Table
		columns={columns}
		dataSource={rows}
		size={width > 1600 ? 'large' : (width > 1200 ? 'middle' : 'small')}
		scroll={{ x: 500 }}
		pagination={{
			total: length,
			current: offset + 1,
			onChange: (page) => setOffset(page - 1),
			defaultPageSize: Number(limit),
			showSizeChanger: false,
		}}
		bordered
		/>
		<Modal
		title="Transaction Details"
		visible={isModalVisible}
		onOk={() => setIsModalVisible(false)}
		onCancel={() => setIsModalVisible(false)}
		>
		<div style={{ padding: '20px', backgroundColor: '#f7f7f7', borderRadius: '8px' }}>
			<p style={{ marginBottom: '10px', color: '#333' }}>
			<strong>Transaction ID: </strong> {currentTransaction ? currentTransaction['transactionId'] : "N/A"}
			</p>
			<p style={{ marginBottom: '10px', color: '#333' }}>
			<strong>Session Duration: </strong> {currentTransaction ? currentTransaction['sessionLength'] : 0} mins
			</p>
			<p style={{ marginBottom: '10px', color: '#333' }}>
			<strong>Charging Duration: </strong> {currentTransaction ? currentTransaction['chargingLength'] : 0} mins
			</p>
			<p style={{ marginBottom: '10px', color: '#333' }}>
			<strong>Started By: </strong> {currentTransaction ? currentTransaction['startedBy'] : "N/A"}
			</p>
			<p style={{ marginBottom: '10px', color: '#333' }}>
			<strong>Stopped By: </strong> {currentTransaction ? currentTransaction['stoppedBy'] : "N/A"}
			</p>
		</div>
		</Modal>
  </>
	  
	);
};

export default TransactionsTable;
